// src/components/StudentDashboard.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useParams } from 'react-router-dom';

export default function StudentDashboard() {
  const { code } = useParams();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newMetric, setNewMetric] = useState({
    applicationsSubmitted: 0,
    connectionsAdded: 0,
    phoneCalls: 0,
    techInterviews: 0,
    hoursStudied: 0,
    selfReflection: '',
  });

  useEffect(() => {
    const studentRef = ref(db, `students/${code}`);
    const unsubscribe = onValue(studentRef, (snapshot) => {
      setStudent(snapshot.val());
      setLoading(false);
    });
    return () => unsubscribe();
  }, [code]);

  const handleAddMetric = async (e) => {
    e.preventDefault();
    if (!student) return;
    const today = new Date().toISOString().split('T')[0];
    const studentRef = ref(db, `students/${code}/dailyMetrics/${today}`);
    await update(studentRef, newMetric);
    setNewMetric({
      applicationsSubmitted: 0,
      connectionsAdded: 0,
      phoneCalls: 0,
      techInterviews: 0,
      hoursStudied: 0,
      selfReflection: '',
    });
  };

  if (loading)
    return <p className='text-white text-center mt-20'>Loading...</p>;
  if (!student)
    return <p className='text-white text-center mt-20'>Student not found</p>;

  return (
    <div className='min-h-screen bg-gradient-to-br from-purple-700 via-indigo-800 to-blue-900 p-8'>
      <div className='max-w-3xl mx-auto bg-white rounded-xl shadow-2xl p-8'>
        <h1 className='text-3xl font-bold mb-6'>
          {student.name} {student.surname}'s Dashboard
        </h1>

        <form onSubmit={handleAddMetric} className='space-y-4 mb-8'>
          <h2 className='text-xl font-semibold'>Add Daily Metric</h2>
          <input
            type='number'
            value={newMetric.applicationsSubmitted}
            onChange={(e) =>
              setNewMetric({
                ...newMetric,
                applicationsSubmitted: parseInt(e.target.value),
              })
            }
            placeholder='Applications Submitted'
            className='w-full p-3 border rounded'
          />
          <input
            type='number'
            value={newMetric.connectionsAdded}
            onChange={(e) =>
              setNewMetric({
                ...newMetric,
                connectionsAdded: parseInt(e.target.value),
              })
            }
            placeholder='Connections Added'
            className='w-full p-3 border rounded'
          />
          <input
            type='number'
            value={newMetric.phoneCalls}
            onChange={(e) =>
              setNewMetric({
                ...newMetric,
                phoneCalls: parseInt(e.target.value),
              })
            }
            placeholder='Phone Calls'
            className='w-full p-3 border rounded'
          />
          <input
            type='number'
            value={newMetric.techInterviews}
            onChange={(e) =>
              setNewMetric({
                ...newMetric,
                techInterviews: parseInt(e.target.value),
              })
            }
            placeholder='Tech Interviews'
            className='w-full p-3 border rounded'
          />
          <input
            type='number'
            value={newMetric.hoursStudied}
            onChange={(e) =>
              setNewMetric({
                ...newMetric,
                hoursStudied: parseInt(e.target.value),
              })
            }
            placeholder='Hours Studied'
            className='w-full p-3 border rounded'
          />
          <textarea
            value={newMetric.selfReflection}
            onChange={(e) =>
              setNewMetric({ ...newMetric, selfReflection: e.target.value })
            }
            placeholder='Self Reflection'
            className='w-full p-3 border rounded'
          />
          <button
            type='submit'
            className='w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700'
          >
            Add Metric
          </button>
        </form>

        <h2 className='text-xl font-semibold mb-2'>Daily Metrics History</h2>
        <div className='space-y-2 max-h-96 overflow-y-auto'>
          {student.dailyMetrics ? (
            Object.entries(student.dailyMetrics)
              .sort(([a], [b]) => new Date(b) - new Date(a))
              .map(([date, m]) => (
                <div key={date} className='p-3 border rounded bg-gray-50'>
                  <p className='font-semibold'>
                    {new Date(date).toDateString()}
                  </p>
                  <p>Applications Submitted: {m.applicationsSubmitted}</p>
                  <p>Connections Added: {m.connectionsAdded}</p>
                  <p>Phone Calls: {m.phoneCalls}</p>
                  <p>Tech Interviews: {m.techInterviews}</p>
                  <p>Hours Studied: {m.hoursStudied}</p>
                  <p>Reflection: {m.selfReflection || '-'}</p>
                </div>
              ))
          ) : (
            <p>No daily metrics yet</p>
          )}
        </div>
      </div>
    </div>
  );
}
